<template>
    <div class="fw-numlist">
        <van-nav-bar :title="title" style="background-color: #CCD5E6;" left-text="" @click-left="onClickLeft" left-arrow
                     :fixed="true">
        </van-nav-bar>
        <div style="padding-top: 18px;padding-right: 16px">
            <el-form ref="form" label-width="100px" size="mini">
                <el-form-item label="客户名称">
                    <div class="fw-numlist-cell">
                        <el-input disabled v-model="member.memberName"></el-input>
                        <div class="numlistbtn">
                            <span class="numlistbtn-text" @click="toMembers">选择</span>
                        </div>
                    </div>
                </el-form-item>
                <el-form-item label="手机号码">
                    <div class="fw-numlist-cell">
                        <el-input v-model="form.phone"></el-input>
                        <div class="numlistbtn">
                            <span class="numlistbtn-text1"></span>
                        </div>
                    </div>
                </el-form-item>
                <el-form-item label="顾客人数">
                    <div class="fw-numlist-cell">
                        <el-input v-model="form.memberNum"></el-input>
                        <div class="numlistbtn">
                            <span class="numlistbtn-text1"></span>
                        </div>
                    </div>
                </el-form-item>
                <el-form-item label="技师级别">
                    <div class="fw-numlist-cell">
                        <el-input disabled v-model="gradeName"></el-input>
                        <div class="numlistbtn">
                            <span class="numlistbtn-text" @click="toGrades">选择</span>
                        </div>
                    </div>
                </el-form-item>
                <el-form-item label="服务项目">
                    <div class="fw-numlist-cell">
                        <el-input disabled v-model="form.fwContent" style="font-size: 9px"></el-input>
                        <div class="numlistbtn">
                            <span class="numlistbtn-text" @click="toItems">选择</span>
                        </div>
                    </div>
                </el-form-item>
                <el-form-item label="人员分配">
                    <div class="fw-numlist-cell">
                        <el-input disabled v-model="empName"></el-input>
                        <div class="numlistbtn">
                            <span class="numlistbtn-text" @click="toEmps">选择</span>
                        </div>
                    </div>
                </el-form-item>
                <el-form-item label="服务号码">
                    <div class="fw-numlist-cell">
                        <el-input disabled v-model="room.roomName"></el-input>
                        <div class="numlistbtn" style="width: 170px">
                            <span class="numlistbtn-text" style="width: 100px;margin-right: 8px"
                                  @click="toFjs">选择房间</span>
                            <span class="numlistbtn-text" @click="delRoom">删除</span>
                        </div>
                    </div>
                </el-form-item>
            </el-form>
            <div style="width: 100%;margin-left: 16px;padding-right: 16px">
                <van-button type="default" class="cj-btn" @click="chuangjian">立即创建</van-button>
            </div>
        </div>
        <van-popup v-model="mbShow" position="bottom" closeable lock-scroll overlay :close-on-click-overlay="false"
                   style="height: 100%;">
            <div style="padding: 15px;margin-top: 12px;display: flex;flex-direction: row;justify-content: center;align-items: center">
                <van-search
                        v-model="money"
                        placeholder="要搜索的手机号 / 姓名"
                        shape="round"
                        style="width: 70%;"
                >
                </van-search>
                <span class="soubtn" @click="onSearch">搜索</span>
                <span class="soubtn" @click="sanke">散客</span>
            </div>
            <div style="display: flex;flex-direction: column;border-top: #dddddd solid 1px;padding-top: 5px;padding: 10px">
                <el-card class="box-card" v-for="item in members">
                    <div slot="header" class="clearfix">
                        <div style="display: flex;flex-direction: row;height: 25px;text-align: center;font-size: 12px">
                            <span style="width: 10%">
                                 <img v-if="item.headPortrait" :src="item.headPortrait"
                                      style="height: 25px;width: 25px">
                                <img v-if="!item.headPortrait&&item.sex==0" src="./../../assets/nan.png"
                                     style="height: 25px;width: 25px">
                                <img v-if="!item.headPortrait&&item.sex==1" src="./../../assets/nan.png"
                                     style="height: 25px;width: 25px">
                                <img v-if="!item.headPortrait&&item.sex==2" src="./../../assets/nv.png"
                                     style="height: 25px;width: 25px">
                            </span>


                            <span style="width: 23%;line-height: 25px;white-space: nowrap;text-overflow: ellipsis;overflow: hidden;">{{item.memberName}}</span>
                            <span style="width: 11%;line-height: 25px">
                                <span v-if="item.sex == 0">未知</span>
                                <span v-if="item.sex == 1">男</span>
                                <span v-if="item.sex == 2">女</span>
                            </span>
                            <span style="width: 23%;line-height: 25px">{{ item.phone }}</span>
                            <span style="width: 23%;line-height: 25px"> {{ item.deptName }}</span>
                        </div>
                        <el-button style="float: right; padding: 3px 0;margin-top: -23px;font-size: 13px" type="text"
                                   @click="setMember(item)">
                            选择
                        </el-button>
                    </div>
                    <div class="card-item" v-if="item.memberCards" v-for="card in item.memberCards">
                        <div style="width: 45%;display: flex;flex-direction: column;justify-content: center;">
                            <span style="line-height: 20px"> {{card.cardName}} ( {{card.itemDiscount}}折 )</span>
                            <span style="line-height: 20px">卡号: {{card.mcNo}}</span>
                        </div>
                        <div style="width: 45%;;display: flex;flex-direction: column">
                            <span style="line-height: 20px">卡余额 : ¥{{card.balance}}</span>
                            <span style="line-height: 20px">赠送金 : ¥{{card.giveBalance}}</span>
                        </div>
                        <!--                        <el-button style="width: 10%;font-size: 13px;text-align: right" type="text"-->
                        <!--                                   @click="setMember(item,card)">-->
                        <!--                            选择-->
                        <!--                        </el-button>-->
                    </div>
                </el-card>
            </div>
        </van-popup>
        <van-popup v-model="jbShow" position="bottom" lock-scroll overlay style="height: 50%;">
            <div class="jb-items">
                <span class="jb-name" v-for="item in grades" @click="setGrade(item)">{{item.gradeName}}</span>
            </div>
        </van-popup>
        <van-popup v-model="empShow" position="bottom" closeable lock-scroll overlay
                   :close-on-click-overlay="false" style="height: 100%;">
             <span class="xmbt">
                    分配员工列表
                </span>
            <div class="emp-items">
                <div class="emp-item" v-for="item in emps" @click="setEmp(item)">
                    <img src="./../../assets/nvemp.jpg" v-if="item.empSex==0" class="emp-img"/>
                    <img src="./../../assets/nanemp.jpg" v-if="item.empSex==1" class="emp-img"/>
                    <span>{{item.nickName}}</span>
                    <span>{{item.gradeName}}</span>
                </div>
            </div>
        </van-popup>
        <van-popup ref="vanpopup" v-model="xmShow" position="bottom" closeable lock-scroll overlay
                   :close-on-click-overlay="false"
                   style="height: 100%;">
                <span class="xmbt" v-if="gradeName">
                    排号选项/{{gradeName}}
                </span>
            <span class="xmbt">
                    排号选项
                </span>
            <v-item ref="vitem" :jbId="form.gradeId" @setData="setData"/>
        </van-popup>

        <van-popup ref="vanpopup" v-model="fjShow" position="bottom" closeable lock-scroll overlay
                   :close-on-click-overlay="false"
                   style="height: 100%;">
                <span class="xmbt">
                    选择房间
                </span>
            <div class="fw-fjs">
                <div class="fw-fjs-item" v-for="item in rooms" @click="toBilling(item)">
                    <span class="fjm">{{item.roomName}}</span>
                    <span class="fj-btn">点击开单</span>
                </div>
            </div>
        </van-popup>
    </div>
</template>

<script>
    import {getCookie} from "../../utils/auth";
    import vItem from './item'

    export default {
        components: {
            vItem
        },
        data() {
            return {
                title: '创建排号',
                deptId: '',
                member: {},
                money: '',
                gradeName: '',
                form: {
                    memberId: '',
                    phone: '',
                    memberNum: 1,
                    gradeId: '',
                    fwContent: '',
                    empId: '',
                },
                serviceNo: '',

                members: [],
                mbShow: false,

                grades: [],
                jbShow: false,

                empName: '',
                emps: [],
                empShow: false,

                items: [],
                xmShow: false,
                rooms: [],
                room: {},
                fjShow: false,
            };
        }
        ,
        async created() {
            document.title = "数字智慧助手"
            this.fwUser = JSON.parse(getCookie("fwUser"))
            this.deptId = this.fwUser.deptId
            this.getGrades()
            this.getFwRooms()
        }
        ,
        methods: {
            async getFwRooms() {
                let data = {
                    deptId: this.deptId,
                }
                let res = await this.$get("/fw/getFwRooms", data)
                this.rooms = res.list
            },
            toFjs() {
                this.fjShow = true
            },
            delRoom() {
                this.room = {}
                this.serviceNo = ''
            },
            toBilling(item) {
                this.room = item
                this.serviceNo = item.roomNo
                this.fjShow = false
            },
            toGrades() {
                this.jbShow = true
            }
            ,
            setGrade(item) {
                this.gradeName = item.gradeName
                this.form.gradeId = item.id
                this.jbShow = false
            },
            toItems() {
                if (this.$refs.vitem) {
                    this.$refs.vitem.getGrades(this.form.gradeId)
                }
                this.xmShow = true
            },

            setData(datas) {
                let str = ''
                datas.forEach(item => {
                    str += item.itemName + ','
                })
                str = str.substring(0, str.length - 1)
                this.form.fwContent = str
                this.items = datas
                this.xmShow = false
            },

            toEmps() {
                if (!this.form.gradeId) {
                    this.$notify({type: 'danger', message: "请先选择技师级别!"});
                    return;
                }
                this.getEmps()
                this.empShow = true
            },
            setEmp(item) {
                this.empName = item.nickName
                this.form.empId = item.id
                this.empShow = false
            },

            async getEmps() {
                let data = {
                    deptId: this.deptId,
                    gradeId: this.form.gradeId
                }
                let res = await this.$get("/fw/getFwNumEmps", data);
                this.emps = res.list
            },

            toMembers() {
                this.money = ''
                this.members = []
                this.mbShow = true
            },

            async onSearch() {
                if (!this.money) {
                    this.$notify("请输入要搜索的手机号 / 姓名!");
                    return;
                }
                let currentPage = 1;
                let data = {
                    deptId: this.deptId,
                    money: this.money,
                    isDel: 0,
                    size: 10,
                    currentPage,
                };
                let res = await this.$get("/fw/getFwMemberForPage", data);
                if (res.code == 200) {
                    this.members = res.dataSet.list;
                }
            },

            sanke() {
                this.form.memberId = ''
                this.member = {}
                this.mbShow = false
            },

            setMember(mb) {
                this.member = mb
                this.form.memberId = mb.id
                this.mbShow = false
            },

            async getGrades() {
                let data = {
                    deptId: this.deptId
                }
                let res = await this.$get("/fw/getFwGradeList", data)
                this.grades = res.list
            },

            async chuangjian() {
                this.form.deptId = this.deptId
                this.form.serviceNo = this.serviceNo
                this.form.itemStr = JSON.stringify(this.items)
                let res = await this.$post("/fw/fwSaveBillingTask", this.form)
                if (res.code == 200) {
                    this.$router.push('/wfp')
                } else {
                    this.$notify({type: 'danger', message: res.message});
                }
            },
            onClickLeft() {
                this.$router.go(-1)
            },
        },
    };
</script>

<style lang="scss" scoped>

    .fw-numlist {
        margin: 0 auto;
        height: 100%;
        position: relative;
        overflow: scroll;
        padding-top: 46px;
    }

    .numlistbtn {
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 13px;
        width: 50px;
        margin-left: 8px;
    }

    .numlistbtn-text {
        width: 45px;
        text-align: center;
        cursor: pointer;
        background-color: #2b94ff;
        color: #ffffff;
        height: 27px;
        line-height: 27px;
    }

    .numlistbtn-text1 {
        width: 45px;
        text-align: center;
        color: #ffffff;
    }

    ::v-deep .el-input .el-input__inner {
        border-color: #EEEEEE !important;
        border-radius: 0px;
    }

    ::v-deep .el-input.is-disabled .el-input__inner {
        background-color: #ffffff;
        border-color: #ffffff;
        color: #C0C4CC;
        cursor: not-allowed;
    }

    ::v-deep .el-form-item--mini.el-form-item {
        margin-bottom: 30px;
    }

    .fw-numlist-cell {
        display: flex;
        flex-direction: row;
    }

    /deep/ .el-card__header {
        padding: 10px;
        border-bottom: 0.02667rem solid #EBEEF5;
        box-sizing: border-box;
        font-size: 13px;
    }

    .card-item {
        display: flex;
        flex-direction: row;
        font-size: 10px;
    }

    /deep/ .el-card__body {
        padding: 10px;
    }

    .soubtn {
        width: 40px;
        font-size: 14px;
        margin: 0px 3px;
    }

    .xiabiao {
        display: block;
        border-bottom: #dddddd solid 1px;
    }

    .jb-items {
        display: flex;
        flex-flow: row wrap;
        padding: 10px 18px;
    }

    .jb-name {
        flex: 1;
        box-sizing: border-box;
        font-size: 13px;
        height: 30px;
        line-height: 30px;
        width: calc((100% - 20px) / 2);
        min-width: calc((100% - 20px) / 2);
        max-width: calc((100% - 20px) / 2);

        &:nth-child(2n + 2) {
            margin-right: 0;
        }

        margin-top: 10px;
        margin-left: 5px;
        margin-right: 5px;
        border: #eeeeee solid 1px;
        text-align: center;
    }

    .emp-items {
        display: flex;
        flex-flow: row wrap;
        padding: 10px 18px;
    }

    .emp-item {
        flex: 1;
        box-sizing: border-box;
        font-size: 10px;
        line-height: 20px;
        width: calc((100% - 40px) / 4);
        min-width: calc((100% - 40px) / 4);
        max-width: calc((100% - 40px) / 4);

        &:nth-child(4n + 4) {
            margin-right: 0;
        }

        margin-top: 10px;
        margin-left: 5px;
        margin-right: 5px;
        padding-bottom: 2px;
        border: #eeeeee solid 1px;
        text-align: center;
        display: flex;
        flex-direction: column;
    }

    .emp-img {
        /*height: 100px;*/
        /*width: 80px;*/
    }

    .xmbt {
        display: block;
        text-align: center;
        font-size: 15px;
        padding: 16px 10px;
        background-color: #CCD5E6;
    }

    .cj-btn {
        width: 100%;
        background-color: #5E5873;
        color: #ffffff;
        height: 38px;
    }

    .fw-fjs {
        display: flex;
        flex-flow: row wrap;
        padding: 0px 8px;
    }

    .fw-fjs-item {
        /*flex: 1;*/
        box-sizing: border-box;
        padding: 8px;
        margin-bottom: 8px;
        display: flex;
        flex-direction: column;
        cursor: pointer;
        width: calc(100% / 3); // 我这里一行显示4个 所以是/4  一行显示几个就除以几
        min-width: calc(100% / 3);
        max-width: calc(100% / 3);

        &:nth-child(3n + 3) {
            margin-right: 0;
        }
    }

    .fjm {
        font-size: 15px;
        height: 60px;
        text-align: center;
        line-height: 60px;
        border-top: silver solid 1px;
        border-left: silver solid 1px;
        border-right: silver solid 1px;
    }

    .fj-btn {
        font-size: 13px;
        text-align: center;
        padding: 5px;
        border: silver solid 1px;
        background-color: #dddddd;
    }

</style>
